import { useEffect, useState } from "react";
import { Link, Navigate, Route, Routes } from "react-router-dom";
import { useAuth } from "../context/authContext";
import { useMediaQuery } from "../hooks/useMediaQuery";
import { useTranslations } from "../hooks/useTranslations";
import { useMe } from "../http/serviceportalApi";
import SVGDescription from "../icons/Description.svg?react";
import { checkHasRevisorPermission } from "../utils";
import AccountButton from "./AccountButton";
import styles from "./RevisorApp.module.css";
import RevisorDocuments from "./RevisorDocuments";
import Sidebar from "./Sidebar";
import AppMenu from "./ui/AppMenu";
import Hamburger from "./ui/Hamburger";
import LoadingSpinner from "./ui/LoadingSpinner";
import Nav from "./ui/Nav";

const RevisorApp = () => {
  const { i18n } = useTranslations();
  const auth = useAuth();
  const matchesMedia = useMediaQuery("(min-width: 1400px)");
  const [isSidebarOpen, setSidebarOpen] = useState(matchesMedia);

  const { data, isValidating } = useMe();
  const userPermissions = data?.permissions ?? [];

  const isRevisor = checkHasRevisorPermission(userPermissions);

  const closeMenu = () => {
    !matchesMedia && setSidebarOpen(false);
  };

  useEffect(closeMenu, [matchesMedia]);

  if (!auth.session || !isRevisor) {
    return null;
  }

  return isValidating ? (
    <div className={styles.loadingSpinner}>
      <LoadingSpinner />
    </div>
  ) : (
    <>
      <header className={styles.header}>
        <div className={styles.aside}>
          <Hamburger
            isOpen={isSidebarOpen}
            className={styles.hamburger}
            onClick={() => setSidebarOpen(!isSidebarOpen)}
          />
          <Link to="/revisoren" className={styles.logo}>
            {i18n.revisorApp.title}
          </Link>
        </div>
        <AppMenu />
        <AccountButton />
      </header>
      <div>
        <Sidebar isOpen={isSidebarOpen} close={closeMenu}>
          <Nav>
            <Nav.Item
              text={i18n.documents.title}
              to="dokumente"
              icon={SVGDescription}
              onClick={closeMenu}
            />
          </Nav>
        </Sidebar>
        <Routes>
          <Route path="dokumente/*" element={<RevisorDocuments />} />
          <Route path="*" element={<Navigate to="dokumente" replace />} />
        </Routes>
      </div>
    </>
  );
};

export default RevisorApp;
